const PVS = Vue.component('pvs', {
    template: `
        <div>
            <div class="row title">
                <div class="col techTitle">
                    <h4>
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}&nbsp;<i class="fas fa-angle-right"></i>&nbsp;{{ $language.pvs }}
                    </h4>
                </div>
            </div>
            <div class="main" id="pvs">
                <div class="row links" v-if="$PVS && $store.state.pvstotals.patentvaluationscore_overallmin">
                    <div class="col-md-12">

                        <table class="table b-table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>{{ $language.pvsmin }}</th>
                                    <th>{{ $language.pvsmax }}</th>
                                    <th>{{ $language.pvsmean }}</th>
                                    <th>{{ $language.pvssum }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="type in types">
                                    <tr>
                                        <td><b>{{ $language["pvs" + type] }}</b></td>
                                        <td>{{ $store.state.pvstotals["patentvaluationscore_" + type + "min"] ? $store.state.pvstotals["patentvaluationscore_" + type + "min"] : 0 }}</td>
                                        <td>{{ $store.state.pvstotals["patentvaluationscore_" + type + "max"] ? $store.state.pvstotals["patentvaluationscore_" + type + "max"] : 0 }}</td>
                                        <td>{{ $store.state.pvstotals["patentvaluationscore_" + type + "mean"] ? $store.state.pvstotals["patentvaluationscore_" + type + "mean"] : 0 }}</td>
                                        <td>{{ $store.state.pvstotals["patentvaluationscore_" + type + "sum"] ? $store.state.pvstotals["patentvaluationscore_" + type + "sum"] : 0 }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <div class="col-md-3 float-right p-0 mt-2 mb-1">
                            <input id="pvsfilter" type="text" class="form-control" :placeholder="$language.publicationfilter" @keyup="filterTable()">
                        </div>

                        <table id="pvspubs" class="table b-table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th><a href='#' class='text-dark' @click.prevent="sortTable('id');">{{ $language.pvspublication }}</a></th>
                                    <template v-for="type in types">
                                        <th><a href='#' class='text-dark' @click.prevent="sortTable(type);">{{ $language["pvs" + type] }}</a></th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="pub in $store.state.pvspubs">
                                <tr>
                                    <td>{{ pub.id }}</td>
                                    <template v-for="type in types">
                                        <td>{{ pub[type] ? pub[type] : 0 }}</td>
                                    </template>
                                </tr>
                                </template>
                            </tbody>
                        </table>

                    </div>
                </div>
                <div v-else>
                    {{ $language.pvsnotfound }}
                </div>
            </div>
        </div>
    `,

    computed: {
        family() {
            return this.$route.params.family;
        },
        totals() {
            return this.$store.getters.pvstotals;
        },
        pubs() {
            return this.$store.getters.pvspubs;
        },
        types() {
            return ["overall", "citation", "commercial", "legal", "technology"];
        }
    },

    data: function() {
        return {
            system: 'pvs',
            pvssort: 'id',
            pvssortreverse: false
        };
    },

    mounted: function() {
        this.$store.commit('addLoadedComponent', 'PVS');

        this.getPVS();

        EventBus.$on('newFamily', () => {
            this.getPVS();
        });

    },

    methods: {
        filterTable() {
            let input = document.getElementById("pvsfilter");
            
            if (!this.$store.state.pvspubs_orig) {
                this.$store.state.pvspubs_orig = this.$store.state.pvspubs;
            }
            
            this.$store.state.pvspubs = this.$store.state.pvspubs_orig;
            
            if (input.value.length > 0) {
                this.$store.state.pvspubs = this.$store.state.pvspubs.filter(function (el) {
                    return el.id.toLowerCase().indexOf(input.value.toLowerCase()) > -1;
                });
            }       
        },
        
        sortTable(type) {
            if (this.pvssort == type) {
                    this.pvssortreverse = !this.pvssortreverse;
            }
            this.pvssort = type;
                
            return this.$store.state.pvspubs.sort((a,b) => {
                let modifier = 1;
                if (this.pvssortreverse) {
                    modifier = -1;
                }

                if(type == 'id') return a[type].localeCompare(b[type]) * modifier;
                if(a[type] < b[type]) return -1 * modifier;
                if(a[type] > b[type]) return 1 * modifier;
                return 0;
            });
        },
        
        getPVS() {
            this.$store.commit('showLoading');

            axios.get('?page=getData&action=pvs', {
                    params: {
                        family: this.family
                    }
                })
                .then(response => {

                    let totals = response.data["totals"];
                    
                    this.$store.commit('storePVSTotals', totals);

                    var pubs = [];

                    response.data["publications"].forEach(pub => {
                        pubs.push({
                            "id": pub.id.replace("_", " "),
                            "overall": pub.c_patentvaluationscore_overall ? pub.c_patentvaluationscore_overall : '',
                            "citation": pub.c_patentvaluationscore_citation ? pub.c_patentvaluationscore_citation : '',
                            "commercial": pub.c_patentvaluationscore_commercial ? pub.c_patentvaluationscore_commercial : '',
                            "legal": pub.c_patentvaluationscore_legal ? pub.c_patentvaluationscore_legal : '',
                            "technology": pub.c_patentvaluationscore_technology ? pub.c_patentvaluationscore_technology : ''
                        });
                    });

                    this.$store.commit('storePVSPubs', pubs);

                    this.$store.commit('hideLoading');

                })
                .catch(err => {
                    console.log(err);
                });
        },

    }
});
